import { gql, useApolloClient } from '@apollo/client';

import { useCallback, useState } from 'react';

export const NOT_REFERENCED_PROJECT_ROLES = gql`
  query ProjectRolesNotReferencedInProjectRateTable(
    $projectId: String!
    $pageSize: Int!
  ) {
    project(projectId: $projectId) {
      id
      projectRolesNotReferencedInProjectRateTable(pageSize: $pageSize) {
        id
        displayText
        name
      }
      projectRolesNotReferencedInProjectRateTableCount
    }
  }
`;

const PAGE_SIZE = 100;

export const useNotReferencedProjectRoles = ({
  projectId,
  pageSize = PAGE_SIZE,
  onComplete
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [role, setRole] = useState({ items: [], count: 0 });

  const client = useApolloClient();

  const fetchNotReferencedProjectRoles = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data } = await client.query({
        query: NOT_REFERENCED_PROJECT_ROLES,
        variables: {
          projectId,
          pageSize
        },
        fetchPolicy: 'network-only'
      });

      setRole({
        items: data?.project?.projectRolesNotReferencedInProjectRateTable || [],
        count:
          data?.project?.projectRolesNotReferencedInProjectRateTableCount || 0
      });
    } catch (err) {
      setRole({ items: [], count: 0 });
    } finally {
      setIsLoading(false);
      onComplete();
    }
  }, [client, onComplete, pageSize, projectId]);

  return {
    fetchNotReferencedProjectRoles,
    isLoading,
    roles: role.items,
    count: role.count,
    notFetchedRolesCount: role.count - role.items.length
  };
};
